import React from 'react';
import PropTypes from 'prop-types';

import { ANNOTATION_CREATE } from 'constants/capabilities';
import CreateNoteContainer from 'containers/forms/CreateNoteContainer';
import ViewNoteTile from 'components/molecules/annotations/ViewNoteTile';
import ProtectedComponent from 'hoc/ProtectedComponent';

const CreateNoteTile = ProtectedComponent({ requiredCapabilities: [ANNOTATION_CREATE] })(props =>
    <React.Fragment>{props.children}</React.Fragment>
);

const DashboardNotesList = (props) => {
    const { notes, dashboard, entityId, deleteNote, showCreateForm, handleToggle } = props;
    const sortedNotes = notes.sort((a, b) => ((a.meta.start > b.meta.start) ? 1 : -1));
    return (
        <React.Fragment>
            <CreateNoteTile>
                {showCreateForm && (
                    <CreateNoteContainer
                        handleToggle={handleToggle}
                        entityId={entityId}
                        dashboard={dashboard}
                    />
                )}
            </CreateNoteTile>


            {sortedNotes.length ? (
                sortedNotes.map((note, index) => (
                    <ViewNoteTile
                        note={note}
                        entityId={entityId}
                        deleteNote={deleteNote}
                        key={index}
                    />
                ))
            ) : null}
        </React.Fragment>
    );
};

DashboardNotesList.propTypes = {
    notes: PropTypes.array,
    dashboard: PropTypes.string,
    entityId: PropTypes.number,
    deleteNote: PropTypes.func
};

export default DashboardNotesList;



// WEBPACK FOOTER //
// ./src/components/organisms/annotations/DashboardNotesList.js